export default "__VITE_ASSET__CrwCMCey__"